import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import { QuestionBase } from "../../../../../pages/create-adv/models/question-base";
import {NgForOf, NgIf, SlicePipe} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {TagManagerDialogComponent} from "../tag-manager-dialog/tag-manager-dialog.component";

@Component({
    selector: 'app-tag-input',
    templateUrl: './tag-input.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        NgForOf,
        NgIf,
        SlicePipe
    ],
    styleUrls: ['./tag-input.component.scss']
})
export class TagInputComponent implements OnInit {
    @Input() question: QuestionBase<any>;
    @Input() form: FormGroup;
    tags: string[] = [];
    @Output() change = new EventEmitter<any>(); // Add this line

    ngOnInit() {
        this.updateTags();
        // Subscribe to value changes so tags update when the form changes
        this.form.get(this.question.key)?.valueChanges.subscribe(() => {
            this.updateTags();
        });
    }

    onInputChange() {
        this.updateTags();
    }

    constructor(public dialog: MatDialog) {}

    openTagManager() {
        const dialogRef = this.dialog.open(TagManagerDialogComponent, {
            data: {
                tags: this.tags,
                separator: '*' // Add separator to question model
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.tags = result;
                this.form.get(this.question.key).setValue(result.join('*'));
                this.form.get(this.question.key).updateValueAndValidity();
                this.change.emit(this.getTrimmedJoinedTags());
            }
        });
    }

    public getTrimmedJoinedTags(): any{
        return {target: {
                value:  this.tags.filter(tag => tag.trim().length > 0).join("*")
        }}
    }

    private updateTags() {
        const value = this.form.get(this.question.key)?.value || '';
        this.tags = value.split('*').filter(tag => tag.trim().length > 0);
        this.change.emit(this.getTrimmedJoinedTags()); // Also emit when tags update
    }
}
